import MaintenanceNotice from "./containers/MaintenanceNotice";

export default MaintenanceNotice;
